import { render, staticRenderFns } from "./person-success.vue?vue&type=template&id=991de9b6&scoped=true&"
import script from "./person-success.vue?vue&type=script&lang=js&"
export * from "./person-success.vue?vue&type=script&lang=js&"
import style0 from "./person-success.vue?vue&type=style&index=0&id=991de9b6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "991de9b6",
  null
  
)

export default component.exports